/**
 * @generated SignedSource<<ea61cac30db997306da041a2be6dd354>>
 * @relayHash fe7b6aeef2ff7293e4725ed5dae04ccf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 58f5ebede16870335101f943d6d18dd3a91ef303ea41352c3fe3a851b3dafa33

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsSpaceOrSiteAdminSpaceAdminQuery$variables = {
  spaceKey: string;
};
export type useIsSpaceOrSiteAdminSpaceAdminQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useIsSpaceOrSiteAdminSpaceAdminQuery = {
  response: useIsSpaceOrSiteAdminSpaceAdminQuery$data;
  variables: useIsSpaceOrSiteAdminSpaceAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe7b6aeef2ff7293e4725ed5dae04ccf",
    "id": "58f5ebede16870335101f943d6d18dd3a91ef303ea41352c3fe3a851b3dafa33",
    "metadata": {},
    "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
    "operationKind": "query",
    "text": "query useIsSpaceOrSiteAdminSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "f2eac010f611ed87c98059843b20682c";

export default node;
